var exports = {
  "uW": "EditBadgesButton.module__section___Umh3OH",
  "DD": "EditBadgesButton.module__title___Umh3OH",
  "h_": "EditBadgesButton.module__description___Umh3OH",
};

module.exports = exports;
